import Divider from "@/components/divider";
import Option from "./Option";

import "./option.css"

type OptionsGroupProps = {
  options: Array<{
    image?: any;
    text: string;
    value: string;
    type?: "MobilePhone" | "Email";
  }>;
  disabled: boolean;
  onSelect: (value: string) => void;
};

export default function OptionsGroup({ options = [], onSelect, disabled }: OptionsGroupProps) {
  if (options.length === 0) return null;

  return (
    <div role="list" aria-label="Opções">
      {options.map((o, index) => {
        const hasDivider = index < options.length - 1;

        return (
          <div
            className={disabled ? "opacity-65" : ""}
            role="listitem"
            key={`options-group-${o.value || index}`}
          >
            <Option
              type={o.type}
              image={o.image}
              text={o.text}
              value={o.value}
              onClick={disabled ? () => { } : () => onSelect(o.value)}
            />

            {hasDivider && <Divider title="Ou" />}
          </div>
        );
      })}
    </div>
  );
}
